<template>
  <section>
    <iframe src="http://arkdata.id/map/indag" style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>Your browser doesn't support iframes</iframe>
  </section>
</template>

